import React from 'react';

import { cn, TableCell } from '@crossnokaye/ux-common';

import { SequenceBox } from './sequence-box';

interface SequenceCellProps {
  children: React.ReactNode;
  className: string;
  disabledTooltipText?: string;
  isColumnActive: boolean;
  isDisabled?: boolean;
  isDirty: boolean;
  isUnavailable?: boolean;
  onClick: () => void;
  original?: string;
  style: React.CSSProperties;
  tooltipContent: string;
}

export const SequenceCell: React.FC<SequenceCellProps> = ({
  children,
  className,
  disabledTooltipText,
  isColumnActive,
  isDisabled,
  isDirty,
  isUnavailable,
  onClick,
  original,
  style,
  tooltipContent,
}) => {
  return (
    <TableCell className={cn('p-0 h-[inherit] border-l-1 border-b-1')}>
      <SequenceBox
        className={cn(className, !isColumnActive ? 'opacity-50' : '')}
        disabledTooltipText={disabledTooltipText}
        isDisabled={isDisabled}
        isDirty={isDirty}
        isUnavailable={isUnavailable}
        onClick={onClick}
        originalValue={original}
        style={style}
        tooltipContent={tooltipContent}
      >
        {children}
      </SequenceBox>
    </TableCell>
  );
};
